export interface FileSystemNode {
  name: string;
  path: string;
  isDirectory: boolean;
  isFile: boolean;
  size: number;
  modified: Date;
  created: Date;
  opened: boolean;
  openedOnce: boolean;
  isRoot: boolean;
  deleted: boolean;
  children: FileSystemNode[];
}

export class NodeClass implements FileSystemNode {
  public name: string;
  public path: string;
  public isDirectory: boolean;
  public isFile: boolean;
  public size: number;
  public modified: Date;
  public created: Date;
  public opened: boolean;
  public openedOnce: boolean;
  public isRoot: boolean;
  public deleted: boolean;
  public children: FileSystemNode[];

  constructor(data: Partial<FileSystemNode>) {
    this.name = data.name || '';
    this.path = data.path || '';
    this.isDirectory = data.isDirectory || false;
    this.isFile = data.isFile || false;
    this.size = data.size || 0;
    this.modified = data.modified || new Date();
    this.created = data.created || new Date();
    this.opened = data.opened || false;
    this.openedOnce = data.openedOnce || false;
    this.isRoot = data.isRoot || false;
    this.deleted = data.deleted || false;
    this.children = data.children || [];
  }

}